import styled from 'styled-components';

import { Text } from '@sternum/ui';
import { Colors } from '@sternum/web/components/theme/constants';
import { mediaQueries } from '@sternum/web/config/mediaQueries';
import { ct } from '@sternum/web/utils/theme';

export const Title = styled(Text)`
  font-size: 14px;
  line-height: 20px;
  font-weight: 600;
  color: ${ct({ Dark: Colors.Darkest, Light: Colors.Darkest })};

  @media (${mediaQueries.lg}) {
    display: inline-block;
    width: 460px;
  }

  @media (${mediaQueries.xl}) {
    font-size: 16px;
    line-height: 24px;
  }
`;

export const List = styled.ul`
  margin-left: 10px;
  color: ${ct({ Dark: Colors.BrandPink, Light: Colors.BrandPink })};
`;

export const ListItem = styled.li`
  margin-bottom: 10px;
`;

export const ListItemText = styled(Text)`
  color: ${ct({ Dark: Colors.DarkerText, Light: Colors.DarkerText })};
  vertical-align: middle;

  font-size: 12px;
  line-height: 18px;

  @media (${mediaQueries.xl}) {
    font-size: 14px;
    line-height: 20px;
  }
`;
